import {Divider as MuiDivider} from "@mui/material";
import {cn} from "@/src/shared/utils/mergeTwClasses";

export function Divider(props: any) {
    const { orientation, horizontalAlign, value, ...restProps } = props;
    return (
        <MuiDivider
            {...restProps}
            textAlign={horizontalAlign}
            className={cn({
                "my-2": orientation === "horizontal",
                "mx-2": orientation === "vertical",
            })}
        >
            {value}
        </MuiDivider>
    );
}